<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">App autenticador</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body text-center p-4">
        <p class="text-secondary mb-3 text-sm">
          Escaneie o QR Code no Google Authenticator, Authy ou similar. Depois
          digite o código de 6 dígitos gerado pelo app.
        </p>

        <div v-if="otpauthUrl" class="qr-wrap mb-3">
          <qrcode-vue :value="otpauthUrl" :size="180" level="M" />
        </div>

        <p v-if="secret" class="text-xs text-secondary mb-3">
          Ou digite a chave manualmente:
          <strong class="secret-text">{{ secret }}</strong>
          <a href="javascript:;" class="text-primary ms-1" @click="copySecret"
            >Copiar</a
          >
        </p>

        <div class="code-input-wrapper mb-4">
          <input
            v-model="internalCode"
            type="text"
            maxlength="6"
            placeholder="000000"
            class="form-control code-input"
            @keyup.enter="confirm"
            ref="codeInput"
            inputmode="numeric"
            @input="internalCode = internalCode.replace(/\D/g, '').slice(0, 6)"
          />
        </div>

        <div class="button-field mt-4">
          <button
            @click="confirm"
            class="btn submit-button"
            :disabled="loading || internalCode.length < 6"
          >
            {{ loading ? "Validando..." : "Confirmar e ativar" }}
          </button>
          <button
            @click="closeModal"
            class="btn cancel-button"
            :disabled="loading"
          >
            Cancelar
          </button>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "TotpSetupModal",
  components: { QrcodeVue },
  props: {
    isOpen: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    secret: { type: String, default: "" },
    otpauthUrl: { type: String, default: "" },
  },
  data() {
    return { internalCode: "" };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.internalCode = "";
        this.$nextTick(() => {
          if (this.$refs.codeInput) this.$refs.codeInput.focus();
        });
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    confirm() {
      if (this.internalCode.length === 6) {
        this.$emit("confirm", this.internalCode);
      }
    },
    async copySecret() {
      try {
        await navigator.clipboard.writeText(this.secret);
        this.$emit("copied");
      } catch (e) {
        /* ignore */
      }
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 450px;
  max-width: 95%;
  background: white;
  border-radius: 16px;
  padding: 24px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid #f0e7fa;
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 15px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: #344767;
  margin: 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  color: #67748e;
  cursor: pointer;
}

.qr-wrap {
  display: flex;
  justify-content: center;
  padding: 14px;
  background: linear-gradient(180deg, #faf7ff 0%, #f8f9fa 100%);
  border-radius: 12px;
  border: 1px solid #efe6fa;
}

.secret-text {
  word-break: break-all;
  font-family: ui-monospace, monospace;
  color: #344767;
}

.code-input-wrapper {
  display: flex;
  justify-content: center;
}

.code-input {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 8px;
  height: 60px;
  border-radius: 12px;
  border: 2px solid #e9ecef;
  background-color: #f8f9fa;
  color: #344767;
  width: 100%;
  max-width: 250px;

  &:focus {
    border-color: #661cb0;
    background-color: white;
    outline: none;
  }
}

.button-field {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submit-button {
  background: linear-gradient(135deg, #661cb0 0%, #e41b80 100%);
  color: white;
  border-radius: 10px;
  height: 48px;
  font-weight: 600;
  border: none;
  box-shadow: 0 8px 18px rgba(228, 27, 128, 0.2);

  &:disabled {
    background: #d2d6da;
    box-shadow: none;
    cursor: not-allowed;
  }
}

.cancel-button {
  background-color: transparent;
  color: #67748e;
  border-radius: 10px;
  height: 48px;
  font-weight: 600;
  border: 1px solid #e9ecef;
}

.text-primary {
  color: #661cb0 !important;
}
</style>
